export enum EtatPetiteAnnonce {
  AttentePaiement = "attente-paiement",
  Payee = "payee",
  Validee = "validee",
  Rejetee = "rejetee",
  Remboursee = "remboursee",
}
